<app-table
  *ngIf="errors"
  [cols]="cols"
  [lazy]="false"
  [elements]="errors"
  pageFunctionName="getErrorsList"
  [service]="shopConfigService"
  modelName="Mensagens de erro de loja"
  sortField="name"
  [sortOrder]="-1"
  [defaultRows]="10"
  [changeColumns]="true"
  [addButton]="false"
/>
<p-toast />
